module.exports = __webpack_public_path__ + "static/media/ecinema.8dd38052.png";